import {
  Map,
  Marker,
  FullscreenControl,
  NavigationControl,
} from 'react-map-gl/maplibre';
import { clsx } from 'clsx';
import { Box } from '@material-ui/core';
import { useEffect, useState } from 'react';

import { RestaurantIcon } from '../icons/restaurant-icon';
import CustomButton from './../common/buttons/custom-button';
import { RTIcon } from '../icons/rt-icon';

import { useRTMapLang } from './useRTMapLang';
import { getCenterAndZoomToMap } from './RTMap.util';

import { MAP_STYLE } from 'constants/MapConfig';
import { DEFAULT_ZOOM } from './RTMap.const';
import useStyles from './RTMap.styles';

function RTMap(props) {
  const {
    classes = {},
    RT,
    store,
    orderId,
    openDialogReleaseRT,
    showReleaseRT = false,
  } = props;

  const existStoreId = store?.store_id;
  const storeLat = store?.lat ?? 0;
  const storeLng = store?.lng ?? 0;
  const RTLat = RT?.lat ?? 0;
  const RTLng = RT?.lng ?? 0;

  const DEFAULT_CENTER = {
    lat: storeLat ?? 4.678695,
    lng: storeLng ?? -74.055456,
  };

  const [viewState, setViewState] = useState(() => {
    const _mapping = getCenterAndZoomToMap(storeLat, storeLng, RTLat, RTLng);
    return {
      latitude: _mapping.center.lat,
      longitude: _mapping.center.lng,
      zoom: _mapping.zoom,
    };
  });

  const lang = useRTMapLang();

  const _classes = useStyles();

  useEffect(() => {
    const mapping = getCenterAndZoomToMap(storeLat, storeLng, RTLat, RTLng);
    setViewState({
      latitude: mapping.center.lat,
      longitude: mapping.center.lng,
      zoom: mapping.zoom,
    });
  }, [RTLat, RTLng, storeLat, storeLng]);

  return (
    <>
      {!existStoreId && (
        <Box flexDirection='column'>
          <h2>{lang.error.loadingMap.title}</h2>
          <p>{lang.error.loadingMap.msg}</p>
        </Box>
      )}
      {existStoreId && (
        <div className={clsx(_classes.root, classes?.root)}>
          <Map
            mapStyle={MAP_STYLE}
            style={{ width: '100%', height: '100%' }}
            initialViewState={{
              zoom: DEFAULT_ZOOM,
              latitude: DEFAULT_CENTER.lat,
              longitude: DEFAULT_CENTER.lng,
            }}
            onMove={evt => setViewState(evt.viewState)}
            {...viewState}
          >
            <Marker anchor='center' latitude={storeLat} longitude={storeLng}>
              <RestaurantIcon className={_classes.restaurantImg} />
            </Marker>
            {RT.id && RT.lat && RT.lng && (
              <Marker anchor='center' latitude={RTLat} longitude={RTLng}>
                <RTIcon direction={RT.bearing} />
              </Marker>
            )}
            <FullscreenControl />
            <NavigationControl />
          </Map>

          {showReleaseRT && (
            <CustomButton
              lat={storeLat}
              lng={storeLng}
              classes={{ root: _classes.releaseRtButton }}
              color='primary'
              disabled={false}
              onClick={() => {
                openDialogReleaseRT(orderId);
              }}
              text={lang.releaseRT.btn}
              variant='contained'
            />
          )}
        </div>
      )}
    </>
  );
}

export default RTMap;
